<template>
  <div>
    <el-card shadow="never" style="margin-bottom: 20px" :headStyle="headStyle">
      <!--      <a slot="extra" href="#">more</a>-->
      <template slot="header">
        <span @click="createError">待办事项</span>
      </template>
      <el-row :gutter="12">
        <el-col :span="8" v-for="item in list" :key="item.title">
          <el-card shadow="never">
            <template slot="header">
              <span>{{ item.title }}</span>
            </template>
            <span>
                Card content
            </span>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
    <el-card shadow="never" :headStyle="headStyle">
      <template slot="header">
        <span>今日仓库情况</span>
      </template>
      <WmsTable :columns="todayConditionH"
                :data-source="dataSource"
                :is-pagination="false"
                bordered>
        <div slot="title" style="margin-right: auto">
          采购单创建时间：2022/01/01 00:00:00 运单号维护时间：2022/01/01 00:00:00
        </div>
        <div slot="jobNumberAction" slot-scope="{text, record, index}">
          {{ text }}
        </div>
        <div slot="nameAction" slot-scope="{text, record, index}">
          {{ text }}
        </div>
        <div slot="expandedRowRender">
          kkkk
        </div>
      </WmsTable>
    </el-card>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
export default {
  name: "Workbench",
  components: {
    WmsTable,
  },
  data() {
    return {
      ModalText: 'Content of the modal',
      visible: false,
      confirmLoading: false,
      todayConditionH: [
        {
          title: '#',
          dataIndex: 'id',
          key: 'id',
          width: 40,
          customRender: (text, record, index) => {
            return index + 1
          },
        },

        {
          title: '检品',
          key: 'checkKey',
          children: [
            {
              title: '初次检查',
              dataIndex: 'firstTimeCheck',
              key: 'firstTimeCheck',
            },
            {
              title: '初次调拨',
              dataIndex: 'firstTimeTransfer',
              key: 'firstTimeTransfer',
            },
            {
              title: '详细检查',
              dataIndex: 'detailedCheck',
              key: 'detailedCheck',
            },
            {
              title: '调拨分拣',
              dataIndex: 'transferSorting',
              key: 'transferSorting',
            },
          ],
        },
        {
          title: '入库',
          key: 'inAmountKey',
          children: [
            {
              title: '小件上架量',
              dataIndex: 'smallAmount',
              key: 'smallAmount',
            },
            {
              title: '大件上架量',
              dataIndex: 'largeAmount',
              key: 'largeAmount',
            }
          ],
        },
        {
          title: '出库',
          key: 'outAmountKey',
          children: [
            {
              title: '配货量',
              dataIndex: 'assignAmount',
              key: 'assignAmount',
            },
            {
              title: '包装量',
              dataIndex: 'packageAmount',
              key: 'packageAmount',
            },
            {
              title: '发货量',
              dataIndex: 'shipAmount',
              key: 'shipAmount',
            }
          ],
        }
      ],
      dataSource: [
        {
          id: 30,
          firstTimeCheck: 100,
          firstTimeTransfer: 200,
          detailedCheck: 300,
          transferSorting: 400,
          smallAmount: 500,
          largeAmount: 600,
          assignAmount: 700,
          packageAmount: 800,
          shipAmount: 1000
        }
      ],
      headStyle: {
        'background-color': '#fafafa',
        'font-weight': '600'
      },
      list: [
        {
          title: '出库',
        },
        {
          title: '检品',
        },
        {
          title: '仓库',
        }
      ]
    }
  },

  methods: {
    createError(){
      throw new Error('aaaaaaaa')
    }
  }
}
</script>

<style scoped>

</style>
